import { render, staticRenderFns } from "./DebriefMobileCard.vue?vue&type=template&id=1a77bd20&scoped=true&"
import script from "./DebriefMobileCard.vue?vue&type=script&lang=js&"
export * from "./DebriefMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77bd20",
  null
  
)

export default component.exports